import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ProductSectionComponentBase } from '../../../ProductSectionComponentBase';
import { ProductSectionComponent } from '../../product-section';
import { ProductComplimentaryComponent } from '../product-complimentary';

@Component({
  selector: 'ideal-product-section-complimentary',
  imports: [ProductSectionComponent, ProductComplimentaryComponent],
  standalone: true,
  templateUrl: './product-section-complimentary.component.html',
  styleUrl: './product-section-complimentary.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.display]': 'hasContent() ? undefined : "none"',
  },
})
export class ProductSectionComplimentaryComponent extends ProductSectionComponentBase {}
